import * as React from "react";
import { InjectRouteParams } from "../../Common/Routing/InjectRouteParams";
import { PermissionRoute } from "../../Common/Routing/PermissionRoute";

const Promotions = React.lazy(() => import("../Promotions/Promotions"));
const PromotionCreate = React.lazy(() => import("../Promotions/PromotionCreate"));
const PromotionModify = React.lazy(() => import("../Promotions/PromotionModify"));
const PromotionView = React.lazy(() => import("../Promotions/PromotionView"));
const PromotionCategories = React.lazy(() => import("../Settings/PromotionCategories/PromotionCategories"));
const MediaCenter = React.lazy(() => import("./MediaCenter/MediaCenter"));

export default function MarketingIndex(): Array<React.ReactNode> {
    return [
        <PermissionRoute
            permissions={[ "see_media_centre" ]}
            title="Media Centre | Shopfront"
            path="/media"
            key="media-center"
            element={<MediaCenter />}
        />,
        <PermissionRoute
            permissions={[ "see_promotions" ]}
            title="Promotions | Shopfront"
            path="/promotions"
            key="promotions"
            element={<Promotions />}
        />,
        <PermissionRoute
            permissions={[ "create_advance_promotions" ]}
            title="Create Promotion | Shopfront"
            path="/promotion/new"
            key="promotion-create"
            element={<PromotionCreate />}
        />,
        <PermissionRoute
            permissions={[ "see_promotions" ]}
            title="Edit Promotion | Shopfront"
            path="/promotion/:id/edit"
            key="promotion-modify"
            element={<InjectRouteParams route={PromotionModify} />}
        />,
        <PermissionRoute
            permissions={[ "see_promotions" ]}
            title="Promotion Categories | Shopfront"
            path="/promotion/categories"
            key="promotion-categories"
            element={<PromotionCategories />}
        />,
        <PermissionRoute
            permissions={[ "see_promotions" ]}
            title="View Promotion | Shopfront"
            path="/promotion/:id"
            key="promotion-view"
            element={<PromotionView />}
        />,
    ];
}
